export enum CardType {
  SINGLE = "SINGLE",
  MULTIPLE = "MULTIPLE",
}

export enum ReceiveStatus {
  NOT_RECEIVED = 0,
  RECEIVED_SUCCESS = 1,
  RECEIVED_FAILED = 2,
}

export const IMAGES = {
  actionButton: "https://i.cdncf.xyz/00e050528e644d06a0bab84e21bf9f4e.png",
  edges: {
    bottomJagged: "https://img.mcd.cn/mini/main/images/personalized-bottom-jagged-edge.png",
    topJagged: "https://img.mcd.cn/mini/main/images/personalized-top-jagged-edge.png",
    topShadow: "https://img.mcd.cn/mini/main/images/personalized-top-shadow.png",
    bottomShadow: "https://img.mcd.cn/mini/main/images/personalized-bottom-shadow.png",
  },
};

export const APP_DEEPLINK = {
  HOME:
    "mcdapp://page?iosPageName=MCDTabBarController&androidPageName=ComponentHome&androidPageAction=home&harmonyPageName=MainPage&parameters=%7b%22selectedIndex%22%3a%220%22%7d",
  COUPON:
    "mcdapp://page?iosPageName=MCDTabBarController&androidPageName=ComponentHome&androidPageAction=home&harmonyPageName=MainPage&parameters=%7b%22selectedIndex%22%3a%223%22%7d",
};

export const CLOSE_ICON = "https://img.mcd.cn/gallery/dfe39c7beb80221b.png";

const BASE_WIDTH = 375;
const screenWidth = window.screen.width;
const calcRatio = (size: number) => (size * screenWidth) / BASE_WIDTH;

export const RATIOS = {
  empty: {
    pageTop: calcRatio(120),
  },
  slogan: {
    height: calcRatio(145),
  },
  machine: {
    height: calcRatio(345),
    cardMarginTop: calcRatio(90),
    cardMarginLeft: calcRatio(36),
    gifMarginLeft: calcRatio(28),
  },
  couponGif: {
    height: calcRatio(204),
    width: calcRatio(279),
  },
  card: {
    single: {
      height: calcRatio(190),
      width: calcRatio(263),
      couponHeight: calcRatio(180),
    },
    listItem: {
      height: calcRatio(90),
    },
    lowerEdge: calcRatio(10),
  },
  button: {
    height: calcRatio(56),
  },
  shadow: {
    top: calcRatio(15),
    bottom: calcRatio(20),
  },
};

/**
 * 领取成功（或首屏已是已领取）后：
 * - CARD_SHOW_DELAY：延时多久再 `setShowCardView(true)` 出券卡，并与 GIF `gifFadeOut`（约 400ms）衔接
 * - BOTTOM_SHADOW_DELAY：再延后多久触发底部阴影渐入，一般 ≥ CARD_SHOW_DELAY
 * 觉得单券出来慢：优先改小 CARD_SHOW_DELAY（例如 200～300）
 */
export const ANIMATION = {
  CARD_SHOW_DELAY: 100,
  BOTTOM_SHADOW_DELAY: 500,
};

export const preloadImages = (images: string[]) => {
  images.forEach((src) => {
    const img = new Image();
    img.src = src;
  });
};

/** 与主接口同结构的静态 JSON；上线前替换为业务提供的 CDN 地址 */
const FIFA_PAGE_INDEX_CDN_FALLBACK_JSON =
  "https://img.mcd.cn/mini/main/json/fifa-coupon-page-index-fallback.json";

export function getFifaPageIndexCdnUrl(matchId: string, teamId: string): string {
  const q = new URLSearchParams({
    matchId: matchId || "",
    teamId: teamId || "",
  });
  return `${FIFA_PAGE_INDEX_CDN_FALLBACK_JSON}?${q.toString()}`;
}


/**
 * 主接口异常或包体不符合约定时改走 CDN：
 * - 业务包体：`code < 0`；`code` 不存在且无可用 `data`（见 hasUsableFifaIndexEnvelope）
 * - 业务包体：495 ≤ code < 600
 */
export function shouldUseFifaIndexCdnFallback(res: any): boolean {
  if (res == null || typeof res !== "object") return true;
  const n = Number(res.code);
  if (Number.isNaN(n)) return true;
  if (n < 0) return true;
  if (n >= 495 && n < 600) return true;
  return false;
}


export async function fetchFifaPageIndexFromCdn(
  matchId: string,
  teamId: string
): Promise<any> {
  const url = getFifaPageIndexCdnUrl(matchId, teamId);
  const r = await fetch(url, { method: "GET", cache: "no-store", credentials: "omit" });
  if (!r.ok) {
    throw new Error(`fifa index cdn http ${r.status}`);
  }
  return r.json();
}
